import {A, Flex, Text} from 'exsportia-components'
import React from 'react'

import {legalFooter} from '../../legal/legal-helpers'
import {useLegalLang} from '../legal/use-legal-lang'

export const ExsportiaCompanyDetails: React.FC = () => {
  const lang = useLegalLang()
  return (
    <Flex maxWidth='480px'>
      <Text settings={{overflow: 'visible', croppedLines: 'unset'}}>
        <div>{legalFooter(lang).line}</div>
        <div>
          WhatsApp Support:{' '}
          <A color={'link'} href='https://wa.me/+66948951432' target='_blank' rel='noopener noreferrer'>
            +66 94 895 1432
          </A>
        </div>
        <div>
          Email:{' '}
          <A color={'link'} href='mailto:info@educationai.group'>
            info@educationai.group
          </A>
          ,{' '}
          <A color={'link'} href='https://www.exsportia.com' target='_blank' rel='noopener noreferrer'>
            www.exsportia.com
          </A>
        </div>
      </Text>
    </Flex>
  )
}
